import { GridSort, VehicleInfo } from '@@partner:types:app'
import { PageInfo } from '@@partner:types:graphql'
import AppLoader from '@components/common/AppLoader'
import React from 'react'
import { EyeSharp } from 'react-ionicons'
import { Table, Tag, Pagination, IconButton, Panel, Button } from 'rsuite'
import { SortType } from 'rsuite/esm/Table'


const { Column, HeaderCell, Cell } = Table

type VehiclesTableProps = {
  vehicles: VehicleInfo[]
  loading: boolean
  error?: any
  pageInfo?: PageInfo
  tableSort: GridSort
  page: number
  onSortColumn: (column: string, sortType?: SortType) => void
  onPageSelect: (page: number) => void
  onOpenVehicle: (vehicle: VehicleInfo) => void
}

export default function VehiclesTable ({
  vehicles,
  loading,
  error,
  pageInfo,
  tableSort,
  page,
  onSortColumn,
  onPageSelect,
  onOpenVehicle
}: VehiclesTableProps) {

  const formatModel = (vehicle: VehicleInfo) => {
    return [ vehicle.brand, vehicle.model, vehicle.year ].filter(Boolean).join(' ') || 'Неизвестно'
  }

  return (
    <Panel header="Список транспорта" bordered>
      <Table
        data={vehicles}
        autoHeight
        wordWrap
        loading={loading}
        sortColumn={tableSort.fieldName}
        sortType={tableSort.sortType}
        onSortColumn={onSortColumn}
        renderLoading={() =>
          loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
        }
        affixHeader
        rowKey="id"
      >
        <Column flexGrow={1} verticalAlign="middle" sortable>
          <HeaderCell>ID</HeaderCell>
          <Cell dataKey="id" />
        </Column>

        <Column sortable flexGrow={1} verticalAlign="middle">
          <HeaderCell>Тип</HeaderCell>
          <Cell dataKey='type.name' />
        </Column>

        <Column sortable flexGrow={1} verticalAlign="middle">
          <HeaderCell>Тип</HeaderCell>
          <Cell>
            {(rowData: VehicleInfo) => formatModel(rowData) || 'Неизвестно'}
          </Cell>
        </Column>
        <Column sortable flexGrow={1} verticalAlign="middle">
          <HeaderCell>Модель</HeaderCell>
          <Cell>
            {(rowData: VehicleInfo) => formatModel(rowData) || 'Неизвестно'}
          </Cell>
        </Column>
        <Column flexGrow={1} verticalAlign="middle" sortable>
          <HeaderCell>Номер</HeaderCell>
          <Cell dataKey="license_plate" />
        </Column>
        

        <Column sortable flexGrow={3} verticalAlign="middle">
          <HeaderCell>Активен</HeaderCell>
          <Cell>
            {(rowData: VehicleInfo) => 
              rowData.is_active ? 'Да' : 'Нет'
            }
          </Cell>
        </Column>

        <Column fixed="right" verticalAlign="middle" flexGrow={2}>
          <HeaderCell>Управление</HeaderCell>
          <Cell>
            {(rowData: VehicleInfo) => (
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                  appearance="ghost"
                  size='sm'
                  onClick={() => onOpenVehicle(rowData)}
                >
                  Просмотр
                </Button>
              </div>
            )}
          </Cell>
        </Column>
      </Table>

      <Pagination
        last
        first
        next
        prev
        ellipsis
        activePage={page}
        pages={pageInfo?.lastPage}
        maxButtons={10}
        total={pageInfo?.total ?? 0}
        onSelect={(eventKey) => onPageSelect(Number(eventKey))}
      />
    </Panel>
  )
}